import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ButtonGroup, Button } from 'ui';
import RadioFieldGroup from 'components/shared/RadioFieldGroup/index';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';
import Fade from 'components/shared/animated/Fade';

const ModalContent = ({ toggleModal, onDelete, error, isRemoving }) => {
  const [deleteImageType, setDeleteImageType] = useState('library');
  const onChange = useCallback(e => {
    setDeleteImageType(e.target.value);
  }, []);

  return (
    <>
      <Modal.Content className="DeleteImageModal-content">
        <div className="mb-32">
          <div className="lh-48 fz-32 c-brand-night">
            {I18n.t('image_library.delete_from_library.title')}
          </div>
        </div>
        <div>
          <div className="lh-48 fz-16 c-brand-gray-darker">
            {I18n.t('image_library.options')}
          </div>
        </div>
        <RadioFieldGroup
          className="ff-ss mt-12"
          selectedValue={deleteImageType}
          name="type"
          onChange={onChange}
        >
          <RadioField className="c-p" value="library">
            <b className="c-brand-night fz-16">
              {I18n.t('image_library.delete_from_library.title')}
            </b>
            <p className="fs-i c-brand-gray-darker fz-16 mb-0 ml-24">
              {I18n.t('image_library.delete_from_library.currently_used')}
              {I18n.t('image_library.delete_from_library.description')}
            </p>
          </RadioField>
          <RadioField className="c-p" value="instances">
            <b className="c-brand-night fz-16">
              {I18n.t(
                'image_library.delete_from_library.delete_all_instances.title',
              )}
            </b>
            <p className="fs-i c-brand-gray-darker fz-16 mb-0 ml-24">
              {I18n.t('image_library.delete_from_library.currently_used')}
              <strong>
                {I18n.t(
                  'image_library.delete_from_library.delete_all_instances.description',
                )}
              </strong>
            </p>
          </RadioField>
        </RadioFieldGroup>
      </Modal.Content>
      <div className="p-32 pt-0">
        <Fade in={error}>
          <div className="ErrorContainer">
            {error && t('common.server_error')}
          </div>
        </Fade>
        <ButtonGroup alignEnd className="ai-c">
          <Button onClick={toggleModal}>{t('common.cancel')}</Button>
          <Button
            loading={isRemoving}
            danger
            onClick={() => onDelete(deleteImageType)}
          >
            {t('common.delete')}
          </Button>
        </ButtonGroup>
      </div>
    </>
  );
};

const DeleteImageModal = ({
  shown,
  toggleModal,
  onDelete,
  error,
  isRemoving,
}) => {
  return (
    <Modal
      shown={shown}
      canClickAway={false}
      onDismiss={toggleModal}
      className="Modal-container DeleteImageModal bg-gray-lightest"
      enableFloatingDismiss
    >
      <ModalContent
        toggleModal={toggleModal}
        onDelete={onDelete}
        error={error}
        isRemoving={isRemoving}
      />
    </Modal>
  );
};

DeleteImageModal.propTypes = {
  shown: PropTypes.bool,
  toggleModal: PropTypes.func,
  onDelete: PropTypes.func,
  error: PropTypes.bool,
  isRemoving: PropTypes.bool,
};

export default DeleteImageModal;
